import React, { useEffect, useReducer } from 'react';

// REDUX
import { UseErrorManager } from '@Managers/ErrorManager/UseErrorManager';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';
import { EGameStoreEvents } from '@Managers/Events/GameStoreEvents';
import { UsePopClient } from '@Managers/PopClient/UsePopClient';
import { getDeviceInfo, getLoggedOut, getMaintananceMode, getReadyState, setCasinoMenu, setGameStoreKey } from '@Managers/Redux/AppState/AppState';
import { useAppDispatch, useAppSelector } from '@Managers/Redux/Hooks';
import { getAuthenticateData, getConfigurationFiles, getUserActionResponseData } from '@Managers/Redux/HttpState';
import { UseGlobalStyles, UseKeyboardEvents, UseWindowDimensions } from './Managers/Device';

// CONFIG
import ConfigLoader from '@ConfigLoader/ConfigLoader';

// TYPES
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';

// CSS
import styles from './App.scss';

// COMPONENTS :: VIEWS
import { TCasinoMenu } from '@Managers/Redux/AppState/AppState.types';
import { LogOut, MaintananceView, ReadyStateCheck, ReadyView } from '@Views/index';

// TOOLS

export const App: React.FC<{}> = ({}) => {
    const [state, setState] = useReducer((state: { ready: boolean; loggedout: boolean }, newState: any) => ({ ...state, ...newState }), {
        ready: false,
        loggedout: false
    });

    const maintananceMode = useAppSelector(getMaintananceMode);
    const loggedout = useAppSelector(getLoggedOut);
    const readyState = useAppSelector(getReadyState);
    const userActionResponseData = useAppSelector(getUserActionResponseData);
    const authenticateResponseData = useAppSelector(getAuthenticateData);
    const device = useAppSelector(getDeviceInfo);

    const dispatch = useAppDispatch();

    ConfigLoader.init();
    UseWindowDimensions();
    UseKeyboardEvents();
    UseGlobalStyles();
    UsePopClient();
    UseErrorManager();

    const handleGameStoreUpdate = (data: { key: EGameStoreKeys; payload: any }) => {
        dispatch(setGameStoreKey({ key: data.key, payload: data.payload[data.key] }));
    };

    useEffect(() => {
        EventsCenter.on(EGameStoreEvents.GAME_STORE_UPDATED, handleGameStoreUpdate);
        dispatch(getConfigurationFiles());
    }, []);

    useEffect(() => {
        if (loggedout) {
            setState({ loggedout: true });
        }

        if (readyState) {
            setState({ ready: true });
        }
    }, [loggedout, readyState]);

    useEffect(() => {
        if (userActionResponseData) {
            EventsCenter.emit(EGameEvents.ACTION_RESPONSE_RECEIVED, { response: userActionResponseData });
        }
    }, [userActionResponseData]);

    useEffect(() => {
        if (authenticateResponseData) {
            if (authenticateResponseData.casinoData) {
                const casinoData: TCasinoMenu = {};
                const authData = authenticateResponseData.casinoData;

                if (authData.cashier) casinoData.cashier = { active: true, title: '', url: decodeURIComponent(authData.cashier) };
                if (authData.history) casinoData.history = { active: true, title: '', url: decodeURIComponent(authData.history) };
                if (authData.lobby) casinoData.lobby = { active: true, title: '', url: decodeURIComponent(authData.lobby) };

                dispatch(setCasinoMenu(casinoData));
            }
        }
    }, [authenticateResponseData]);

    return (
        <div className={styles.app_container}>
            {maintananceMode.active ? <MaintananceView /> : <> {state.loggedout ? <LogOut /> : <>{state.ready ? <ReadyView /> : <ReadyStateCheck />}</>}</>}
        </div>
    );
};

export default App;
